<template>
  <div class="box box-info">
    <div class="p-fluid p-formgrid p-grid">
        <a href="#" @click.prevent="exportCSV()" v-if="this.inventoryClosingStockLists.length > 0">
          <img src="../../../../static/img/excel.png"
               style="height: 3.5em;width: 3.5em;float: right;margin-right: 4em;"/>
        </a>
      <div class="p-field p-col-12 p-col-12">
      
        <DataTable
          :value="inventoryClosingStockLists"
          :paginator="true" ref="po"
          :rows="100" :filters="filters"
          editMode="cell"
          :rowsPerPageOptions="[100,500,1000]"
          class="p-datatable-responsive p-datatable-gridlines"
        >
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>

          <Column headerStyle="width: 16em" header="Name" field="itemName" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['itemName']"/>
            </template>
          </Column>
          <Column header="Code" field="itemCode" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
            </template>
          </Column>

          <Column header="Unit" field="unit" :sortable="true" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['unit']"/>
            </template>
          </Column>
          <Column header="Closing Stock" bodyStyle="text-align: right" :sortable="true" field="closingQuantity"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['closingQuantity']"/>
            </template>
          </Column>
          <Column header="Size" >
            <template #body="slotProps">
          <Button class="p-button-raised p-button-success"
                            @click.prevent="openBasic(slotProps)"
                            icon="pi pi-eye"/>
            </template>
           </Column>
          <template #empty>No record found</template>
        </DataTable>
      </div>
    </div>
    <Dialog header="Size Details" :visible.sync="displayBasic"
                    :style="{width: '50vw', height:'20vw'}" :modal="true" :closable=false
                    :contentStyle="{'overflow': 'visible'}">
              <!-- <form> -->
                <!-- <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Size</label>
                    <Dropdown
                      v-model="sizeName"
                      :options="sizeLists"
                      optionLabel="label"
                      optionValue="value"
                      :filter="true"
                      placeholder="Select Size"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Quantity</label>
                  <InputNumber id="quantity" mode="decimal" onfocus="if (this.value === '0.00'){this.value = ''}"
                         v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
                  </div>
    
                  <div class="p-field p-col-12 p-md-1 p-mt-5">
                    <Button class="p-button-raised"
                             @click.prevent="addInventoryStockSize" label="Add"/>
                  </div>
                </div> -->
              <!-- </form> -->
              <table class="table table-bordered" style="margin-top: 2em;border: 1px solid #c8c8c8;">
                <thead>
                <tr>
                  <th>S.N</th>
                  <th>Size</th>
                  <th>Color</th>
                  <th>Quantity</th>
                  <!-- <th>Amount</th> -->
                  <!-- <th>Action</th> -->
                </tr>
                </thead>
                <tbody v-for="(expense,index) in inventoryStockSizeList" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ expense.size }}</td>
                  <td>{{ expense.color }}</td>
                  <td>{{ expense.quantity }}</td>
                  <!-- <td>{{ expense.extraExpenseAmt }}</td> -->
                  <!-- <td>
                    <Button class="p-button-raised p-button-success"
                            @click.prevent="editExtraExpensesDto(expense,index)"
                            icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger"
                            @click.prevent="removeExtraExpense(expense, index)"
                            icon="pi pi-trash"/>
                  </td> -->
                </tr>
                </tbody>
              </table>
              <template #footer>
                <!-- <Button class="p-button-raised p-button-rounded" @click.prevent="closeBasic" label="Save"/> -->
                <Button @click.prevent="closeBasic" class="p-button-raised p-button-danger"
                        label="Back"/>
              </template>
            </Dialog>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'

export default {
  name: 'PosItemClosingStock',
  data() {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      inventoryStockSizeList: [],
      filters: {},
      inStock: 0,
      displayBasic: false
    }
  },
  computed: {
    inventoryClosingStockLists() {
      return this.$store.state.inventoryReport.inventoryClosingStockLists
    }
  },
  mounted() {
    this.inventoryClosingStockList()
    this.columnNames()
  },
  methods: {
    async inventoryClosingStockList() {
      await this.$store.dispatch('loadClosingStockForPos')
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportInventory/' + 0 + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + '2078-04-01' + '/' + '2078-04-01' + '/Pos Closing Stock' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'closingStockPos.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    openBasic(data) {
      this.inventoryStockSizeList = data.data.inventorySizeDetailsDTOList
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    Dialog
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// posClosingStock.vue?61b65a58